import { lazy, Suspense } from 'react';

import { Route, Routes } from 'react-router-dom';

const Notifications = lazy(() => import('./Notifications/pages/notifications'));

export const InboxsRouting = () => {
  return (
    <Routes>
      <Route
        path="notifications"
        element={
          <Suspense fallback={<></>}>
            <Notifications />
          </Suspense>
        }
      />
    </Routes>
  );
};
